import React from 'react';
import InfoTooltip from 'components/shared/InfoTooltip';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import { Icon } from 'ui';
import { BetaFeedback } from 'components/BetaProgram';
import EMAILS from 'constants/emails';
import KeywordMatching from './KeywordMatching';
import FillerWords from './FillerWords';
import WordsPerMinute from './WordsPerMinute';
import ConfidenceScore from './ConfidenceScore';

const AutomatedAnalysis = ({
  getAutomatedAnalysisKeywordsPath,
  addAutomatedAnalysisKeywordPath,
  removeAutomatedAnalysisKeywordPath,
  applyChanges,
  handleUpdate,
  content,
}) => {
  const onChange = value => {
    applyChanges(value);
    handleUpdate(value);
  };

  return (
    <div className="mt-32 mb-32" data-testid="AutomatedAnalysis">
      <div className="d-f ai-c df-r pb-4">
        <Text variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD}>
          {t('automated_analysis.automated_analysis_overall.title')}
        </Text>
        <span className="d-ib ml-8">
          <InfoTooltip
            className="c-gray-light"
            tooltip={t('automated_analysis.automated_analysis_overall.tooltip')}
          />
        </span>
      </div>
      <div className="d-f">
        <Text className="" variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD}>
          {t('automated_analysis.automated_analysis_overall.hint')}
        </Text>
      </div>
      <KeywordMatching
        content={content}
        getAutomatedAnalysisKeywordsPath={getAutomatedAnalysisKeywordsPath}
        addAutomatedAnalysisKeywordPath={addAutomatedAnalysisKeywordPath}
        removeAutomatedAnalysisKeywordPath={removeAutomatedAnalysisKeywordPath}
        onChange={onChange}
      />
      <div className="d-f fd-c">
        <FillerWords content={content} onChange={onChange} />
        <WordsPerMinute content={content} onChange={onChange} />
        <ConfidenceScore content={content} onChange={onChange} />
      </div>
      <div className="d-f jc-sb">
        <a
          className="pt-16 c-brand-blue"
          href="https://intercom.help/lessonly/en/articles/5941683-automated-coaching-for-practice-responses"
          target="_blank"
          rel="noreferrer noopener"
        >
          <Text variant={TEXT_VARIANTS.BODY_LINK} className="td-n">
            {t('automated_analysis.automated_analysis_overall.view_example')}
          </Text>
          <Icon name="external-link" className="ml-8 h-18 w-18" />
        </a>
        <BetaFeedback
          className="pt-16 aa-editor"
          betaFeatureName="Automated Analysis"
          recipient={EMAILS.PRACTICE_FEEDBACK}
        />
      </div>
    </div>
  );
};

export default AutomatedAnalysis;
